import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Grid } from "@client/shared/components";
import style from "./style";
import { globalStyles, noop } from "@client/shared/constants";
import { updateLayout } from "@client/utils";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";

const SiteView = ({
  entries = [],
  entriesCount = 0,
  columnConfig = [],
  pageNumber = 1,
  pageSize = 5,
  order = null,
  orderBy = "",
  isLoading = false,
  isOpen = false,
  continueId = "",
  subscriptionId ="",
  handlePageNumberChange = noop,
  handlePageSizeChange = noop,
  handleSortChange = noop,
  handleSelectionChange = noop,
  handleGridReady = noop,
  handleClose = noop,
  handlePatch = noop,
}) => {
  const location = useLocation();
  useEffect(() => {
    setTimeout(() => updateLayout("site-page-wrapper"), 400);
  }, [location.pathname]);

  return (
    <div id="site-page-wrapper">
        <Paper
          elevation={0}
          sx={{
            p: 2,
            m:2,
            ...style.pageTitleWrapper,
          }}
        >
          <Box
            sx={{
              ...globalStyles.display.flex,
              ...globalStyles.flex.justify.between,
            }}
          >
            <Box>
              <Typography variant="h6">Sites</Typography>
              <Typography
                variant="body2"
                sx={{
                  ...globalStyles.text.color.secondaryText,
                }}
              >
                Below are the sites associated with the account.
              </Typography>
            </Box>
          </Box>
        </Paper>
        <Paper
          elevation={0}
          sx={{
            mt: 2,
            m:2,
            ...style.tablePaper,
          }}
        >
          <Grid
            hasSelection={false}
            hasPagination
            rows={entries}
            totalRows={entriesCount}
            isLoading={isLoading}
            columns={columnConfig}
            pageSize={pageSize}
            pageNumber={pageNumber}
            order={order}
            orderBy={orderBy}
            onPageNumberChange={handlePageNumberChange}
            onPageSizeChange={handlePageSizeChange}
            onSortChange={handleSortChange}
            onSelectionChange={handleSelectionChange}
            onReady={handleGridReady}
            entriesText="Events"
          />
        </Paper>   

      <Dialog open={isOpen} onClose={handleClose}>
        <DialogTitle sx={style.dialogTitle}>
          Are you sure?
          <IconButton onClick={handleClose} sx={{ ml: 20 }}>
            <CloseIcon sx={{ color: "#B0B0B0" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={style.dialogContent}>
          <Box sx={{ mt: 2 }}></Box>
          <Typography variant="body1" sx={style.heading}>
            Removing subscription id for this site will result in failure to
            create call logs in CRM for users of this site.
          </Typography>
        </DialogContent>
        <DialogActions sx={style.actions}>
          <Button
            onClick={handleClose}
            variant="text"
            sx={{ ...style.actionButtons, color: "grey.600" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() =>
              handlePatch(continueId, {
                subscription_id:subscriptionId,
              })
            }
            variant="contained"
            color="primary"
            sx={style.actionButtons}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SiteView;
